import React, { useState, useEffect, useRef } from 'react';
import { FaDollarSign } from 'react-icons/fa6';
import productService from '../services/productService';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const Pricing = () => {
    const [products, setProducts] = useState([]);
    const [packs,setPacks] = useState([])
    const [regularCategories, setRegularCategories] = useState([]);
    const [rentalCategories, setRentalCategories] = useState([]);
    const [userId, setUserId] = useState(null);
    const tableRef = useRef(null);
    const fixImageUrl = (url) => {
        if (!url) return '/logo.png';
        return url.replace('../http:', 'http:');
      };
    const fetchPricing = async() => {
        try {
            const response = await productService.pricing();
            setProducts(  response.products.filter((p)=> p.is_pack != 1));
            setPacks(  response.packs);

            setRegularCategories(response.categories);
            setRentalCategories(response.rentalcategories);
            setUserId(response.userId);
        } catch (error) {
            console.error('Error fetching pricing:', error);
        }
    };

    useEffect(() => {
        fetchPricing();
    }, []);

 

const exportPDF = () => {
  try {
    const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const marginX = 12;
    const topPad = 24;

    const dateStr = new Date().toLocaleString();
    const formatGBP = (v) => `£${Number(v || 0).toFixed(2)}`;

    const addHeader = () => {
      pdf.setFillColor(7, 41, 77); // navy traka
      pdf.rect(0, 0, pageW, 18, 'F');
      pdf.setTextColor(255);
      pdf.setFontSize(13);
      pdf.text('Golden Group Linen — Pricing', marginX, 12);
      pdf.setFontSize(9);
      pdf.text(`Generated: ${dateStr}`, pageW - marginX, 12, { align: 'right' });
      pdf.setTextColor(30);
    };

    const addFooter = (data) => {
      const pageCount = pdf.getNumberOfPages();
      pdf.setFontSize(9);
      pdf.setTextColor(120);
      pdf.text(`Page ${data.pageNumber} of ${pageCount}`, pageW - marginX, pageH - 8, { align: 'right' });
      pdf.setTextColor(30);
    };

    addHeader();
    let cursorY = topPad;

    // ---- REGULAR (LINEN HIRE) ----
    pdf.setFontSize(12);
    pdf.text('LINEN HIRE (Regular)', marginX, cursorY);
    cursorY += 4;

    (regularCategories || []).forEach((cat, idx) => {
      // Naslov kategorije
      autoTable(pdf, {
        startY: idx === 0 ? cursorY + 2 : (pdf.lastAutoTable?.finalY || cursorY) + 6,
        margin: { left: marginX, right: marginX },
        head: [[cat.category_title]],
        body: [],
        theme: 'plain',
        styles: { fontSize: 11, cellPadding: 2 },
        headStyles: { fillColor: [242, 242, 242], textColor: [30, 30, 30] },
        didDrawPage: addFooter,
      });

      // PACKS samo za kategoriju #1
      if (cat.id === 1 && Array.isArray(packs) && packs.length) {
        const packRows = (typeof getPacks === 'function' ? getPacks() : packs)
          .map((pk) => [
            `GG-${pk.id}`,
            `${pk.name || ''}${pk.description ? ` — ${pk.description}` : ''}`,
            formatGBP(pk.price),
          ]);

        if (packRows.length) {
          autoTable(pdf, {
            margin: { left: marginX, right: marginX },
            startY: pdf.lastAutoTable.finalY + 2,
            head: [['Code', 'Pack', 'Price']],
            body: packRows,
            styles: { fontSize: 9, cellPadding: 2 },
            headStyles: { fillColor: [7, 41, 77], textColor: 255 },
            theme: 'grid',
            didDrawPage: addFooter,
          });
        }
      }

      // Proizvodi u kategoriji
      const prods = typeof getCategoryProducts === 'function'
        ? getCategoryProducts(cat.id)
        : (products || []).filter(
            (p) => p.category_id === cat.id && ![83,84,85,86,87,88,89,90,91,92,93,94,95].includes(p.id)
          );

      const prodRows = (prods || []).map((p) => [
        p.product_code || '',
        p.product_title || '',
        formatGBP(p.price),
      ]);

      autoTable(pdf, {
        margin: { left: marginX, right: marginX },
        startY: pdf.lastAutoTable ? pdf.lastAutoTable.finalY + 2 : cursorY + 6,
        head: [['Code', 'Product', 'Price']],
        body: prodRows,
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: { fillColor: [7, 41, 77], textColor: 255 },
        theme: 'grid',
        didDrawPage: addFooter,
      });
    });

    // Prelomi stranu prije RENTAL ako smo pri dnu
    if (pdf.lastAutoTable && (pdf.lastAutoTable.finalY > pageH - 40)) {
      pdf.addPage();
      addHeader();
    }

    // ---- RENTAL ----
    autoTable(pdf, {
      startY: pdf.lastAutoTable ? pdf.lastAutoTable.finalY + 10 : topPad + 6,
      margin: { left: marginX, right: marginX },
      head: [['RENTAL']],
      body: [],
      theme: 'plain',
      styles: { fontSize: 11, cellPadding: 2 },
      headStyles: { fillColor: [242, 242, 242], textColor: [30, 30, 30] },
      didDrawPage: addFooter,
    });

    (rentalCategories || []).forEach((cat) => {
      // Naslov kategorije
      autoTable(pdf, {
        margin: { left: marginX, right: marginX },
        startY: pdf.lastAutoTable.finalY + 2,
        head: [[cat.category_title]],
        body: [],
        theme: 'plain',
        styles: { fontSize: 10, cellPadding: 1.5 },
        headStyles: { fillColor: [250, 250, 250], textColor: [60, 60, 60] },
        didDrawPage: addFooter,
      });

      // Proizvodi sa 4 perioda cijene
      const prods = typeof getCategoryProducts === 'function'
        ? getCategoryProducts(cat.id)
        : (products || []).filter(
            (p) => p.category_id === cat.id && ![83,84,85,86,87,88,89,90,91,92,93,94,95].includes(p.id)
          );

      const rows = (prods || []).map((p) => [
        p.product_code || '',
        p.product_title || '',
        formatGBP(p.priceone),   // 3 Days
        formatGBP(p.pricetwo),   // 1 Week
        formatGBP(p.pricethree), // 2 Weeks
        formatGBP(p.pricefour),  // 1 Month
      ]);

      autoTable(pdf, {
        margin: { left: marginX, right: marginX },
        startY: pdf.lastAutoTable.finalY + 1,
        head: [['Code', 'Product', '3 Days', '1 Week', '2 Weeks', '1 Month']],
        body: rows,
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: { fillColor: [7, 41, 77], textColor: 255 },
        theme: 'grid',
        didDrawPage: addFooter,
      });
    });

    pdf.save(`pricing-${new Date().toISOString().slice(0, 10)}.pdf`);
  } catch (e) {
    console.error('PDF export error:', e);
  }
};


    // Helper function to get products for a category
    const getCategoryProducts = (categoryId) => {
        return products.filter(product => 
            product.category_id === categoryId && 
            ![83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95].includes(product.id)
        );
    };

    // Get packs for category 1 (LINEN HIRE)
    const getPacks = () => {
        return packs.sort((a,b) => a.sort - b.sort)
    };

    return (
        <div className="p-3 sm:p-6 overflow-x-hidden">
            {/* <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-golden-navy flex items-center">
                    <img src="/logo.png" alt="Pricing" className="h-6 w-6 mr-2" />
                    Pricing
                </h1>
            </div> */}

            <div className="flex flex-col sm:flex-row gap-2 mb-4">
                <div className="bg-golden-navy text-center text-white px-4 py-3 rounded-lg w-full">
                    For further enquiry please contact us on info@goldengroup.uk
                </div>
                <button 
                    className="min-h-12 w-full sm:w-60 bg-golden-navy text-white rounded-lg hover:bg-opacity-90 transition-colors duration-300"
                    onClick={exportPDF}
                >
                    Export as pdf
                </button>
            </div>

            <div className="sm:hidden space-y-4" ref={tableRef}>
                {regularCategories?.map(category => (
                    <section key={`mobile-${category.id}`} className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                        <h2 className="bg-golden-navy px-4 py-3 text-center font-semibold text-white">
                            {category.category_title}
                        </h2>
                        <div className="divide-y divide-gray-100">
                            {category.id === 1 && getPacks()?.map(pack => (
                                <article key={`mobile-pack-${pack.id}`} className="flex gap-3 p-4">
                                    <img src={fixImageUrl(pack.image)} alt="" className="h-12 w-12 shrink-0 rounded-lg object-cover bg-gray-50" />
                                    <div className="min-w-0 flex-1">
                                        <div className="flex items-start justify-between gap-3">
                                            <div>
                                                <p className="font-semibold text-golden-navy">{pack.name}</p>
                                                <p className="text-xs text-gray-500">GG-{pack.id}</p>
                                            </div>
                                            <strong className="whitespace-nowrap text-golden-navy">£{parseFloat(pack.price || 0).toFixed(2)}</strong>
                                        </div>
                                        {pack.description ? <p className="mt-2 text-sm leading-5 text-gray-600">{pack.description}</p> : null}
                                    </div>
                                </article>
                            ))}
                            {getCategoryProducts(category.id).filter(product => product.is_pack !== '1').map(product => (
                                <article key={`mobile-product-${product.id}`} className="flex items-center gap-3 p-4">
                                    <img src={fixImageUrl(product.image)} alt="" className="h-12 w-12 shrink-0 rounded-lg object-cover bg-gray-50" />
                                    <div className="min-w-0 flex-1">
                                        <p className="font-semibold text-golden-navy">{product.product_title}</p>
                                        <p className="text-xs text-gray-500">{product.product_code}</p>
                                    </div>
                                    <strong className="whitespace-nowrap text-golden-navy">£{parseFloat(product.price || 0).toFixed(2)}</strong>
                                </article>
                            ))}
                        </div>
                    </section>
                ))}
                {rentalCategories?.map(category => (
                    <section key={`mobile-rental-${category.id}`} className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                        <h2 className="bg-golden-navy px-4 py-3 text-center font-semibold text-white">{category.category_title}</h2>
                        <div className="divide-y divide-gray-100">
                            {getCategoryProducts(category.id)?.map(product => (
                                <article key={`mobile-rental-product-${product.id}`} className="p-4">
                                    <div className="flex items-center gap-3">
                                        <img src={fixImageUrl(product.image)} alt="" className="h-12 w-12 shrink-0 rounded-lg object-cover bg-gray-50" />
                                        <div className="min-w-0">
                                            <p className="font-semibold text-golden-navy">{product.product_title}</p>
                                            <p className="text-xs text-gray-500">{product.product_code}</p>
                                        </div>
                                    </div>
                                    <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                                        <span>3 days <strong className="float-right">£{parseFloat(product.priceone || 0).toFixed(2)}</strong></span>
                                        <span>1 week <strong className="float-right">£{parseFloat(product.pricetwo || 0).toFixed(2)}</strong></span>
                                        <span>2 weeks <strong className="float-right">£{parseFloat(product.pricethree || 0).toFixed(2)}</strong></span>
                                        <span>1 month <strong className="float-right">£{parseFloat(product.pricefour || 0).toFixed(2)}</strong></span>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </section>
                ))}
            </div>

            <div className="hidden sm:block bg-white rounded-lg shadow overflow-x-auto" ref={tableRef}>
                <table className="w-full min-w-[560px]">
                    <thead className="bg-golden-navy text-white">
                        <tr>
                            <th className="p-4 text-left">Product ID</th>
                            <th className="p-4 text-left">Product</th>
                            <th className="p-4 text-right">Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Regular Categories */}
                        {regularCategories?.map(category => (
                            <React.Fragment key={category.id}>
                                <tr className="bg-navy-900">
                                    <td colSpan="3" className="p-3 bg-golden-navy bg-opacity-90 text-white font-semibold text-center">
                                        {category.category_title}
                                    </td>
                                </tr>
                                {/* Render packs first if this is category 1 */}
                                {category.id ==1 && getPacks()?.map(pack => (
                                    <tr key={`pack-${pack.id}`} className="border-b hover:bg-gray-50">
                                        <td className="p-2">GG-{pack.id}</td>
                                        <td className="p-2 flex items-center">
                                            <img 
                                                src={fixImageUrl(pack.image) ?? '/placeholder.jpg'} 
                                                alt={pack.name}
                                                className="w-10 h-10 object-cover rounded-lg mr-2"
                                            />
                                            <div>
                                           <p> {pack.name}</p>
                                            <p><i> {pack.description}</i></p>
                                            </div>
                                        </td>
                                        <td className="p-2 text-right">
                                            £{parseFloat(pack.price || 0).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                                {/* Render regular products */}
                                {getCategoryProducts(category.id)
                                    .filter(product => product.is_pack !== '1')
                                    .map(product => (
                                    <tr key={product.id} className="border-b hover:bg-gray-50">
                                        <td className="p-2">{product.product_code}</td>
                                        <td className="p-2 flex items-center">
                                            <img 
                                                src={fixImageUrl(product.image) ?? '/placeholder.jpg'} 
                                                alt={product.product_title}
                                                className="w-10 h-10 object-cover rounded-lg mr-2"
                                            />
                                            {product.product_title}
                                        </td>
                                        <td className="p-2 text-right">
                                            £{parseFloat(product.price || 0).toFixed(2)}
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}

                        {/* Rental Categories */}
                        {rentalCategories?.map(category => (
                            <React.Fragment key={category.id}>
                                <tr className="bg-navy-900">
                                    <td colSpan="3" className="p-3 bg-golden-navy bg-opacity-90 text-white font-semibold text-center">
                                        {category.category_title}
                                    </td>
                                </tr>
                                {getCategoryProducts(category.id)?.map(product => (
                                    <tr key={product.id} className="border-b hover:bg-gray-50">
                                        <td className="p-2">{product.product_code}</td>
                                        <td className="p-2 flex items-center">
                                            <img 
                                                src={fixImageUrl(product.image) ?? '/placeholder.jpg'} 
                                                alt={product.product_title}
                                                className="w-10 h-10 object-cover rounded-lg mr-2"
                                            />
                                            {product.product_title}
                                        </td>
                                        <td className="p-2 text-right">
                                            <div>3 Days: £{parseFloat(product.priceone || 0).toFixed(2)}</div>
                                            <div>1 Week: £{parseFloat(product.pricetwo || 0).toFixed(2)}</div>
                                            <div>2 Weeks: £{parseFloat(product.pricethree || 0).toFixed(2)}</div>
                                            <div>1 Month: £{parseFloat(product.pricefour || 0).toFixed(2)}</div>
                                        </td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Pricing;
